import JsBarcode from 'jsbarcode'

function textToBase64Barcode(text = '', options = {}) {
  var canvas = document.createElement('canvas')
  JsBarcode(canvas, text, options)
  return canvas.toDataURL('image/png')
}

export default textToBase64Barcode
